/**
 * Swiper Utilities
 * A collection of helper functions for Swiper instances
 */

// Initialize a Swiper instance with automatic arrow opacity handling
function initSwiperWithArrows(swiperSelector, options = {}) {
  // Default navigation selectors
  const defaultOptions = {
    prevEl: ".swiper-button-prev",
    nextEl: ".swiper-button-next",
    opacityValue: 0.3,
  };

  // Merge default options with user options
  const settings = { ...defaultOptions, ...options };

  // Get navigation selectors from options or use defaults
  const prevSelector = options.navigation?.prevEl || settings.prevEl;
  const nextSelector = options.navigation?.nextEl || settings.nextEl;

  // Add our event handlers to the options
  const enhancedOptions = {
    ...options,
    on: {
      ...options.on,
      init: function () {
        setTimeout(
          () =>
            updateArrowOpacity(
              this,
              prevSelector,
              nextSelector,
              settings.opacityValue
            ),
          100
        );
        // Call original init if it exists
        if (options.on?.init) options.on.init.call(this);
      },
      slideChange: function () {
        updateArrowOpacity(
          this,
          prevSelector,
          nextSelector,
          settings.opacityValue
        );
        // Call original slideChange if it exists
        if (options.on?.slideChange) options.on.slideChange.call(this);
      },
      resize: function () {
        updateArrowOpacity(
          this,
          prevSelector,
          nextSelector,
          settings.opacityValue
        );
        // Call original resize if it exists
        if (options.on?.resize) options.on.resize.call(this);
      },
      fromEdge: function () {
        updateArrowOpacity(
          this,
          prevSelector,
          nextSelector,
          settings.opacityValue
        );
        // Call original fromEdge if it exists
        if (options.on?.fromEdge) options.on.fromEdge.call(this);
      },
      reachEnd: function () {
        updateArrowOpacity(
          this,
          prevSelector,
          nextSelector,
          settings.opacityValue
        );
        // Call original reachEnd if it exists
        if (options.on?.reachEnd) options.on.reachEnd.call(this);
      },
      reachBeginning: function () {
        updateArrowOpacity(
          this,
          prevSelector,
          nextSelector,
          settings.opacityValue
        );
        // Call original reachBeginning if it exists
        if (options.on?.reachBeginning) options.on.reachBeginning.call(this);
      },
      afterInit: function () {
        updateArrowOpacity(
          this,
          prevSelector,
          nextSelector,
          settings.opacityValue
        );
        // Call original afterInit if it exists
        if (options.on?.afterInit) options.on.afterInit.call(this);
      },
    },
  };

  // Initialize the swiper with enhanced options
  return new Swiper(swiperSelector, enhancedOptions);
}

// Helper function to update arrow opacity based on swiper state
function updateArrowOpacity(
  swiper,
  prevSelector,
  nextSelector,
  opacityValue = 0.3
) {
  if (!swiper) return;

  const prevButton = document.querySelector(prevSelector);
  const nextButton = document.querySelector(nextSelector);

  if (prevButton) {
    if (swiper.isBeginning) {
      prevButton.style.opacity = opacityValue.toString();
      prevButton.style.pointerEvents = "none";
    } else {
      prevButton.style.opacity = "1";
      prevButton.style.pointerEvents = "auto";
    }
  }

  if (nextButton) {
    if (swiper.isEnd) {
      nextButton.style.opacity = opacityValue.toString();
      nextButton.style.pointerEvents = "none";
    } else {
      nextButton.style.opacity = "1";
      nextButton.style.pointerEvents = "auto";
    }
  }
}
